import { render, staticRenderFns } from "./EmployeeWorkgroupPicker.vue?vue&type=template&id=0e60ac64&"
import script from "./EmployeeWorkgroupPicker.vue?vue&type=script&lang=ts&"
export * from "./EmployeeWorkgroupPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports